import { useEffect, useRef } from "react";

import { event } from "@/components/utils/gtag";

const THRESHOLDS = [25, 50, 75, 100];

// ページのスクロール深度（25/50/75/100%）を計測し、しきい値ごとに1回だけGA4へ送信する
export default function useScrollDepth(label = "") {
  const sentRef = useRef({});

  useEffect(() => {
    sentRef.current = {};

    const handleScroll = () => {
      const scrollTop =
        window.scrollY || document.documentElement.scrollTop || 0;
      const docHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      if (docHeight <= 0) {
        return;
      }

      const percent = (scrollTop / docHeight) * 100;
      // 高DPI環境やサブピクセル誤差で最下部でも100%に届かないことがあるため、
      // 実質的に最下部へ到達しているか（許容誤差2px）も併せて判定する
      const isBottom =
        scrollTop + window.innerHeight >=
        document.documentElement.scrollHeight - 2;

      THRESHOLDS.forEach((threshold) => {
        const reached =
          threshold === 100 ? percent >= 100 || isBottom : percent >= threshold;
        if (reached && !sentRef.current[threshold]) {
          sentRef.current[threshold] = true;
          event({
            action: "scroll_depth",
            category: "webinar",
            label: { depth: String(threshold), page: label },
          });
        }
      });
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    // 初期表示時点で下部まで見えているケースにも対応する
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [label]);
}
